import type { CameraType } from '../../../shared/domain/flows/types.no-deps'
import { Plat_isIOS } from './Plat.device'

/**
 * Note to all consumers. On Android, when using this method the OS may kill the main process and we need to be able
 * to recover state using the url alone.
 */
export async function Plat_cordovaGetMedia(
    uploadSource: 'gallery' | 'camera',
    targetDimension: number,
    mediaType: CameraType = 'photo'
) {
    const cordovaMediaType = {
        photo: navigator.camera.MediaType.PICTURE,
        video: navigator.camera.MediaType.VIDEO,
        any: navigator.camera.MediaType.ALLMEDIA,
    }

    return new Promise<string>((resolve, reject) => {
        const succeed = (media: MediaFile[] | string) => {
            resolve(formatMediaUrl(Array.isArray(media) ? media[0].fullPath : media))
        }

        if (uploadSource === 'camera' && mediaType === 'video') {
            return navigator.device.capture.captureVideo(succeed, reject, { limit: 1 })
        }

        navigator.camera.getPicture(succeed, reject, {
            mediaType: cordovaMediaType[mediaType],
            sourceType:
                uploadSource === 'gallery'
                    ? navigator.camera.PictureSourceType.SAVEDPHOTOALBUM
                    : navigator.camera.PictureSourceType.CAMERA,
            targetWidth: targetDimension,
            targetHeight: targetDimension,
            saveToPhotoAlbum: Plat_isIOS() && uploadSource === 'camera',
            correctOrientation: true,
        })
    })
}

const formatMediaUrl = (url: string): string => {
    // For some reason when selecting a video from the gallery, getPicture
    // does not append the file protocol to the file. This is a workaround
    // until we replace it in #5652
    if (typeof url === 'string' && !url.startsWith('file://')) {
        return 'file://' + url
    }

    return url
}
